import { PublicClientApplication, BrowserCacheLocation } from "@azure/msal-browser";
import { getAuthConfig } from "utils/auth";
export const SCOPES = [`api://${getAuthConfig().clientId}/all`];
export default class AuthProvider {
    static instance;
    application;
    constructor() {
        if (AuthProvider.instance) {
            throw new Error("Instantiation failed: use AuthProvider.getInstance() instead of new");
        }
        else {
            this.application = new PublicClientApplication({
                auth: getAuthConfig(),
                cache: {
                    cacheLocation: BrowserCacheLocation.LocalStorage,
                },
            });
        }
    }
    static async getInstance() {
        if (!AuthProvider.instance) {
            const instance = new AuthProvider();
            await instance.application.initialize(); // ✅ REQUIRED
            AuthProvider.instance = instance;
        }
        return AuthProvider.instance;
    }
    async checkAuth() {
        const response = await this.application.handleRedirectPromise();
        const accounts = this.application.getAllAccounts();
        if (response?.account) {
            this.application.setActiveAccount(response.account);
            return response.account;
        }
        if (accounts.length > 0) {
            this.application.setActiveAccount(accounts[0]);
            return accounts[0];
        }
        return null;
    }
    async login() {
        await this.application.loginRedirect({
            scopes: SCOPES,
            prompt: "select_account",
        });
    }
    logout() {
        this.application.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }
    async getAccessToken() {
        try {
            const accounts = this.application.getAllAccounts();
            if (!accounts || accounts.length === 0) {
                throw new Error("login_required");
            }
            const silentResult = await this.application.acquireTokenSilent({
                scopes: SCOPES,
                account: accounts[0],
            });
            return silentResult.accessToken;
        }
        catch (err) {
            await this.application.acquireTokenRedirect({ scopes: SCOPES });
            return "";
        }
    }
}
